<!-- Toolbar -->
<div class="nav-wrapper toolbar" role="banner">
  <nav class="navbar">
    <div class="logo">
      <img
        width="70"
        alt="CK Capital Finance Logo"
        src="assets/ck-capital-finance-logo.png"
      />
      <h3>CK Capital Finance</h3>
    </div>
    <div class="menu-toggle" id="mobile-menu" (click)='toggleMenu()'>
      <span class="bar"></span>
      <span class="bar"></span>
      <span class="bar"></span>
    </div>
    <ul class="nav" id="menu">
      <li class="nav-item"><a href="https://www.ckcapitalfinance.com/"><h5 style="margin-top:15px;margin-right:-10px">HOME</h5></a></li>
      <!-- <li class="nav-item"><a href="https://www.ckcapitalfinance.com/services">SERVICES</a></li> -->
      <li class="nav-item"><a href="https://www.ckcapitalfinance.com/about">ABOUT US</a></li>
      <li class="nav-item"><a href="https://www.ckcapitalfinance.com/contact">CONTACT US</a></li>
      <li class="nav-item">
        <a aria-label="CK Capital on Facebook" target="_blank" rel="noopener" href="https://www.facebook.com/ckcapitalfinance/" title="CK Capital Facebook" style="padding-right:30px">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"/></svg>
        </a>
      </li>
    </ul>
  </nav>
</div>


<div class="col-12">
  <h1 style="text-align:center;padding-bottom:25px;margin-top:15px" class="pt-8">CK Capital Finance<br/>Loan Application</h1>
  <h1 style="text-align:center;padding-bottom:25px;" *ngIf="isReferralValid">Referred By: {{referralDisplayName}}</h1>
  <p-messages></p-messages>
  <p-toast key="tst"></p-toast>
  <form (ngSubmit)="applicationSubmit(applicationForm)" [formGroup]="applicationForm">
    <input type="hidden" [(ngModel)]="referralWebAddress" formControlName="ReferralName" /> 
    <div class="grid boxs">
      <!-- <div class="col-12 sm:col-12 md:col-6">
        <div class="input_fields">
          <label>Loan Officer</label>
          <input type="text" pInputText [(ngModel)]="loan_officer" formControlName="LoanOfficer" />
        </div>
      </div> -->
      <div class="col-12 sm:col-12 md:col-16">
        <div class="input_fields">
          <label>How Did You Hear About Us?</label>
          <input type="text" pInputText [(ngModel)]="how_you_heard_about_us" formControlName="HowDidYouHear" />
        </div>
      </div>
      <div class="col-12">
        <h3>BORROWER/ENTITIY INFORMATION</h3>
      </div>
      <div class="col-12">
        <div class="input_fields">
          <label>Entity Name <span style="color:red">*</span></label>
          <input type="text" pInputText [(ngModel)]="entity_name" formControlName="EntityName" />
        </div>
      </div>
      <div class="col-12 sm:col-12 md:col-6">
        <div class="input_fields">
          <label>Type <span style="color:red">*</span></label>
          <p-dropdown [options]="entityType" [style]="{'width':'100%'}" [(ngModel)]="entity_type" formControlName="EntityType"></p-dropdown>
        </div>
      </div>
      <div class="col-12 sm:col-12 md:col-6">
        <div class="input_fields">
          <label>EIN Number <span style="color:red">*</span></label>
          <p-inputMask [(ngModel)]="entity_ein_number" [style]="{'width':'100%'}" mask="99-9999999" formControlName="EINNumber"></p-inputMask>
        </div>
      </div>
      <div class="col-12 sm:col-12">
        <h3>PERSONAL GUARANTOR INFORMATION </h3>
      </div>
      <div class="col-12 sm:col-12 md:col-6">
        <div class="input_fields">
          <label>First Name <span style="color:red">*</span></label>
          <input type="text" pInputText [(ngModel)]="personal_first_name" formControlName="PersonalFirstName" />
        </div>
      </div>
      <div class="col-12 sm:col-12 md:col-6">
        <div class="input_fields">
          <label>Last Name <span style="color:red">*</span></label>
          <input type="text" pInputText [(ngModel)]="personal_last_name" formControlName="PersonalLastName" />
        </div>
      </div>
      <div class="col-12 sm:col-12 md:col-6">
        <div class="input_fields">
          <label>Date of Birth <span style="color:red">*</span></label>
          <p-calendar [style]="{'width':'85%'}" [showIcon]="true" [monthNavigator]="true" [yearNavigator]="true" yearRange="1900:2050" [inputStyle]="{'width':'85%'}" [(ngModel)]="personal_date_of_birth" formControlName="PersonalBirthDate"></p-calendar>
        </div>
      </div>
      <div class="col-12 sm:col-12 md:col-6">
        <div class="input_fields">
          <label>Social Security Number <span style="color:red">*</span></label>
          <p-inputMask [(ngModel)]="personal_ssn" mask="999-99-9999" formControlName="PersonalSSN"></p-inputMask>
        </div>
      </div>
      <div class="col-12">
        <div class="input_fields">
          <label>Primary Residence Address <span style="color:red">*</span></label>
          <input type="text" pInputText [(ngModel)]="personal_primary_residence" formControlName="PersonalPrimaryResidence" />
        </div>
      </div>
      <div class="col-12 sm:col-12 md:col-4">
        <div class="input_fields">
          <label>City <span style="color:red">*</span></label>
          <input type="text" pInputText [(ngModel)]="personal_city" formControlName="PersonalCity"/>
        </div>
      </div>


          <div class="col-12 sm:col-12 md:col-4">
            <div class="input_fields">
              <label>State <span style="color:red">*</span></label>
              <p-dropdown [options]="states" [style]="{'width':'100%'}" [(ngModel)]="personal_state" formControlName="PersonalState"></p-dropdown>
            </div>
          </div>
          <div class="col-12 sm:col-12 md:col-4">
            <div class="input_fields">
              <label>Zip <span style="color:red">*</span></label>
              <p-inputMask [(ngModel)]="personal_zip" styleClass="p-inputwrapper" mask="99999" formControlName="PersonalZip"></p-inputMask>
            </div>
          </div>


      <div class="col-12 sm:col-12 md:col-6">
        <div class="input_fields">
          <label>Own or Rent?  <span style="color:red">*</span></label>
          <p-dropdown [options]="ownOrRent" [style]="{'width':'100%'}" [(ngModel)]="personal_own_or_rent" formControlName="PersonalOwnOrRent"></p-dropdown>
        </div>
      </div>
      <div class="col-12 sm:col-12 md:col-6">
        <div class="input_fields">
          <label>Number of Years <span style="color:red">*</span></label>
          <input type="number" pInputText [(ngModel)]="personal_number_of_years" formControlName="PersonalOwnOrRentNumberOfYears"/>
        </div>
      </div>
      <div class="col-12 sm:col-12 md:col-6">
        <div class="input_fields">
          <label>Phone <span style="color:red">*</span></label>
          <p-inputMask [(ngModel)]="personal_phone_number" mask="(999) 999-9999" formControlName="PersonalPhone"></p-inputMask>
        </div>
      </div>
      <div class="col-12 sm:col-12 md:col-6">
        <div class="input_fields">
          <label>Email Address <span style="color:red">*</span></label>
          <input type="text" pInputText [(ngModel)]="personal_email" formControlName="PersonalEmail" email/>
        </div>
      </div>
      <div class="col-12">
        <h3>BORROWER EXPERIENCE </h3>
      </div>
      <div class="col-12">
        <div class="input_fields">
          <label class="big">Number of properties rehabbed and sold within the last 36 months <span style="color:red">*</span></label>
          <input type="number" pInputText [(ngModel)]="experience_properties_rehabbed" formControlName="ExperienceRehab" />
        </div>
      </div>
      <div class="col-12">
        <div class="input_fields">
          <label class="big">Number of rental properties currently owned <span style="color:red">*</span></label>
          <input type="number" pInputText [(ngModel)]="experience_rental_properties_currently_owned" formControlName="ExperienceRental" />
        </div>
      </div>
      <div class="col-12">
        <div class="input_fields">
          <label class="big">Number of properties with PROOF of YOUR ACTUAL ownership history <span style="color:red">*</span></label>
          <input type="number" pInputText [(ngModel)]="experience_proof_ownership" formControlName="ExperienceProofOwnership" />
        </div>
      </div>
      <div class="col-12">
        <h3>SUBJECT PROPERTY INFORMATION </h3>
      </div>
      <div class="col-12">
        <p-checkbox binary=true label="Check this if you are only looking to be pre-approved" inputId="PreApprovalOnly" [(ngModel)]="pre_approval_only" formControlName="SeekingPreApprovalOnly"></p-checkbox>
      </div>
      <div class="col-12">
        <p-checkbox binary=true label="Check this if you do NOT have a subject property picked out" inputId="SubjectPropertyNotPicked" [(ngModel)]="no_subject_property" formControlName="NoSubjectProperty"></p-checkbox>
      </div>
      <div class="col-12">
        <p-checkbox binary=true [hidden]="no_subject_property" label="Check this if you ARE currently under contract" (onChange)="underContractChange($event)" inputId="UnderContract" [(ngModel)]="under_contract" formControlName="UnderContract"></p-checkbox>
      </div>
      <div *ngIf="!no_subject_property" class="col-12">
        <div class="input_fields">
          <label>Property Address <span style="color:red">*</span></label>
          <input type="text" pInputText [(ngModel)]="property_address" formControlName="SubjectPropertyAddress" />
        </div>
      </div>
      <div *ngIf="!no_subject_property" class="col-12 sm:col-12 md:col-6">
        <div class="input_fields">
          <label>City <span style="color:red">*</span></label>
          <input type="text" pInputText [(ngModel)]="property_city" formControlName="SubjectCity" />
        </div>
      </div>

      <div *ngIf="!no_subject_property" class="col-12 sm:col-12 md:col-6">
        <div class="input_fields">
          <label>State <span style="color:red">*</span></label>
          <p-dropdown [options]="states" [style]="{'width':'100%'}" [(ngModel)]="property_state" formControlName="SubjectState"></p-dropdown>
        </div>
      </div>
      <div *ngIf="!no_subject_property" class="col-12 sm:col-12 md:col-6">
        <div class="input_fields">
          <label>Zip <span style="color:red">*</span></label>
          <p-inputMask [(ngModel)]="property_zip" mask="99999" formControlName="SubjectZip"></p-inputMask>
        </div>
      </div>
        
      <div class="col-12 sm:col-12 md:col-6">
        <div class="input_fields">
          <label>Exit Strategy <span style="color:red">*</span></label>
          <p-dropdown [options]="exitStrategy" [style]="{'width':'100%'}" [(ngModel)]="property_exit_strategy" formControlName="PropertyExitStrategy"></p-dropdown>
        </div>
      </div>
      <div class="col-12 sm:col-12 md:col-6">
        <div class="input_fields">
          <label>Property Type <span style="color:red">*</span></label>
          <p-dropdown [options]="propertyType" [style]="{'width':'100%'}" [(ngModel)]="property_type" formControlName="SubjectPropertyType"></p-dropdown>
        </div>
      </div>
      <div class="col-12">
        <h3>LOAN REQUEST INFORMATION  </h3>
      </div>
      <div class="col-12 sm:col-12 md:col-6">
        <div class="input_fields">
          <label>Program Type <span style="color:red">*</span></label>
          <p-dropdown [options]="programType" [style]="{'width':'100%'}" [(ngModel)]="loan_program_type" formControlName="LoanProgramType"></p-dropdown>
        </div>
      </div>
      <div class="col-12 sm:col-12 md:col-6">
        <div class="input_fields">
          <label>Mortgage Type <span style="color:red">*</span></label>
          <p-dropdown [options]="mortgageType" [style]="{'width':'100%'}" [(ngModel)]="loan_mortgage_type" formControlName="MortgageType"></p-dropdown>
        </div>
      </div>
      <div class="col-12 sm:col-12 md:col-6">
        <div class="input_fields">
          <label>Purchase Price </label>
          <input type="number" pInputText [(ngModel)]="loan_purchase_price" formControlName="PurchasePrice" />
        </div>
      </div>
      <div class="col-12 sm:col-12 md:col-6">
        <div class="input_fields">
          <label>Loan Term </label>
          <p-dropdown [options]="loanTerm" [style]="{'width':'100%'}" [(ngModel)]="loan_term" formControlName="LoanTermMonths"></p-dropdown>
        </div>
      </div>
      <div class="col-12 sm:col-12 md:col-6">
        <div class="input_fields">
          <label>Rehab Cost <small>(if applicable) </small></label>
          <input type="number" pInputText [(ngModel)]="loan_rehab_cost" formControlName="RehabCost" />
        </div>
      </div>
      <div class="col-12 sm:col-12 md:col-6">
        <div class="input_fields">
          <label>After Repaired Value  <small>(if applicable) </small></label>
          <input type="number" pInputText [(ngModel)]="loan_after_repaired_value" formControlName="AfterRepairValue"/>
        </div>
      </div>
      <div class="col-12" id="RehabBudgetContainer" *ngIf="loan_rehab_cost != null && no_subject_property == false">
        <h3 style="color:white;margin-bottom:0px;">
          <i class="pi pi-exclamation-triangle" style="color:#e72a2b"></i> 
          REHAB BUDGET FORM (REQUIRED) 
          <i class="pi pi-exclamation-triangle" style="color:#e72a2b"></i>
        </h3>
        <app-rehab-budget [rehabTotal]="loan_rehab_cost"></app-rehab-budget>
      </div>
      <div class="col-12">
        <h6>If Refinancing - please complete the following: </h6>
      </div>
      <div class="col-12 sm:col-12 md:col-6">
        <div class="input_fields">
          <label>Original Purchase Price </label>
          <input type="number" pInputText [(ngModel)]="refinance_orig_purchase_price" formControlName="RefinanceOriginalPurchasePrice"/>
        </div>
      </div>
      <div class="col-12 sm:col-12 md:col-6">
        <div class="input_fields">
          <label>Current Payoff </label>
          <input type="number" pInputText [(ngModel)]="refinance_current_payoff" formControlName="RefinanceCurrentPayoff"/>
        </div>
      </div>
      <div class="col-12 sm:col-12 md:col-6">
        <div class="input_fields">
          <label>Date Acquired </label>
          <p-calendar [style]="{'width':'85%'}" [monthNavigator]="true" [yearNavigator]="true" yearRange="1900:2050" [showIcon]="true" [inputStyle]="{'width':'85%'}" [(ngModel)]="refinance_date_acquired" formControlName="RefinanceDateAcquired"></p-calendar>
        </div>
      </div>
      <div class="col-12 sm:col-12 md:col-6">
        <div class="input_fields">
          <label>Payment Amount  </label>
          <input type="number" pInputText [(ngModel)]="refinance_payment_amount" formControlName="RefinancePaymentAmount"/>
        </div>
      </div>
      <div class="col-12 sm:col-12 md:col-6">
        <div class="input_fields">
          <label>Mortgage Lender </label>
          <input type="text" pInputText [(ngModel)]="refinance_mortgage_lender" formControlName="RefinanceMortgageLender"/>
        </div>
      </div>
      <div class="col-12 sm:col-12 md:col-6">
        <div class="input_fields">
          <label>Contact Name </label>
          <input type="text" pInputText [(ngModel)]="refinance_contact_name" formControlName="RefinanceContactName"/>
        </div>
      </div>
      <div class="col-12 sm:col-12 md:col-6">
        <div class="input_fields">
          <label>Email </label>
          <input type="text" pInputText [(ngModel)]="refinance_mortgage_email" formControlName="RefinanceMortgageEmail" email/>
        </div>
      </div>
      <div class="col-12 sm:col-12 md:col-6">
        <div class="input_fields">
          <label>Phone</label>
          <p-inputMask [(ngModel)]="refinance_phone" mask="(999) 999-9999" formControlName="RefinancePhone"></p-inputMask>
        </div>
      </div>
      <div class="col-12 sm:col-12 md:col-6">
        <div class="signature_pad_box">
          <signature-pad #sigpad1 [options]="signaturePadOptions"  id="SignatureLoanPart" (onEndEvent)="signatureLoanPartDrawComplete()"></signature-pad>
          <div class="sign_box">Guarantor Signature  <span (click)="clearSignatureLoanPart()" style="cursor:pointer;">(Click Here To Clear Signature)</span></div>
        </div>
      </div>
      <div class="col-12 sm:col-12 md:col-6">
        <p-calendar [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}" [disabled]="true" [(ngModel)]="loan_info_signature_date" formControlName="LoanInfoSignatureDate"></p-calendar>
        <div class="sign_box" style="margin-top:5px;">Date</div>
      </div>
      <div class="col-12">
        <h6>If Leased - please complete the following: </h6>
      </div>
      <div class="col-12 sm:col-12 md:col-6">
        <div class="input_fields">
          <label>Monthly Rent </label>
          <input type="number" pInputText [(ngModel)]="leased_monthly_rent" formControlName="LeasedMonthlyRent" />
        </div>
      </div>
      <div class="col-12 sm:col-12 md:col-6">
          <div class="col-12 sm:col-6 md:col-8 lg:col-8">
            <div class="input_fields">
              <label>Lease Expiration Date</label>
              <p-calendar [monthNavigator]="true" [disabled]="leased_month_to_month" [yearNavigator]="true" yearRange="1900:2050" [showIcon]="true" [inputStyle]="{'width':'62%'}" [(ngModel)]="leased_lease_expiration_date" formControlName="LeasedExpiration"></p-calendar>
            </div>
          </div>
          <div class="col-12 sm:col-6 md:col-6 lg:col-6">
            <p-checkbox binary=true label="Already Expired & Doing Month-to-month" inputId="LeasedExpired" [(ngModel)]="leased_month_to_month" formControlName="LeaseMonthToMonth"></p-checkbox>
          </div>
      </div>
      <div class="col-12 sm:col-12 md:col-6">
        <div class="input_fields">
          <label>Yearly Taxes </label>
          <input type="number" pInputText [(ngModel)]="leased_yearly_taxes" formControlName="LeasedYearlyTaxes" />
        </div>
      </div>
      <div class="col-12 sm:col-12 md:col-6">
        <div class="input_fields">
          <label>Yearly Insurance </label>
          <input type="number" pInputText [(ngModel)]="leased_yearly_insurance" formControlName="LeasedYearlyInsurance" />
        </div>
      </div>
      <div class="col-12 sm:col-12 md:col-6">
        <div class="input_fields">
          <label>Yearly HOA Dues <small>(if applicable)</small></label>
          <input type="number" pInputText [(ngModel)]="leased_yearly_hoa_dues" formControlName="LeasedYearlyHOADues" />
        </div>
      </div>
      <div class="col-12 sm:col-12 md:col-6">
        <div class="input_fields">
          <label>HOA Contact</label>
          <input type="text" pInputText [(ngModel)]="leased_hoa_contact" formControlName="LeasedHOAContact" />
        </div>
      </div>
      <div class="col-12">
        <h3>CONTACT INFORMATION</h3>
      </div>
      <div class="col-12 sm:col-12 md:col-6">
        <h6>Interior Access Contact Information </h6>
        <div class="col-12">
          <div class="input_fields">
            <label>Contact Name</label>
            <input type="text" pInputText [(ngModel)]="contact_interior_contact_name" formControlName="InteriorContact" />
          </div>
        </div>
        <div class="col-12">
          <div class="input_fields">
            <label>Relationship</label>
            <input type="text" pInputText [(ngModel)]="contact_interior_relationship" formControlName="InteriorContactRelationship" />
          </div>
        </div>
        <div class="col-12">
          <div class="input_fields">
            <label>Email</label>
            <input type="text" pInputText [(ngModel)]="contact_interior_email" formControlName="InteriorContactEmail" email />
          </div>
        </div>
        <div class="col-12">
          <div class="input_fields">
            <label>Phone</label>
            <p-inputMask [(ngModel)]="contact_title_phone" mask="(999) 999-9999" formControlName="InteriorContactPhone"></p-inputMask>
          </div>
        </div>
      </div>
      <div class="col-12 sm:col-12 md:col-6">
        <h6>Title/Escrow Contact Information</h6>
        <div class="col-12">
          <div class="input_fields">
            <label>Company Name</label>
            <input type="text" pInputText [(ngModel)]="contact_title_company_name" formControlName="ContactTitleCompanyName" />
          </div>
        </div>
        <div class="col-12">
          <div class="input_fields">
            <label>Contact Name</label>
            <input type="text" pInputText [(ngModel)]="contact_title_company_contact_name" formControlName="ContactTitleContactName" />
          </div>
        </div>
        <div class="col-12">
          <div class="input_fields">
            <label>Email</label>
            <input type="text" pInputText [(ngModel)]="contact_title_email" formControlName="ContactTitleEmail" email />
          </div>
        </div>
        <div class="col-12">
          <div class="input_fields">
            <label>Phone</label>
            <p-inputMask [(ngModel)]="refinance_phone" mask="(999) 999-9999" formControlName="ContactTitlePhone"></p-inputMask>
          </div>
        </div>
      </div>
      <div class="col-12">
        <h6>Home Owners Insurance (HOI) Contact Information (if applicable)</h6>
      </div>
      <div class="col-12 sm:col-12 md:col-6">
        <div class="input_fields">
          <label>Contact Name</label>
          <input type="text" pInputText [(ngModel)]="hoa_contact_name" formControlName="HOAContactName" />
        </div>
      </div>
      <div class="col-12 sm:col-12 md:col-6">
        <div class="input_fields">
          <label>Relationship </label>
          <input type="text" pInputText [(ngModel)]="hoa_relationship" formControlName="HOARelationship" />
        </div>
      </div>
      <div class="col-12 sm:col-12 md:col-6">
        <div class="input_fields">
          <label>Email</label>
          <input type="text" pInputText [(ngModel)]="hoa_contact_email" formControlName="HOAContactEmail" email />
        </div>
      </div>
      <div class="col-12 sm:col-12 md:col-6">
        <div class="input_fields">
          <label>Phone </label>
          <p-inputMask [(ngModel)]="hoa_phone" mask="(999) 999-9999" formControlName="HOAPhone"></p-inputMask>
        </div>
      </div>
      <div class="col-12">
        <h3>DECLARATIONS </h3>
      </div>
      <div class="col-12">
        <div class="input_fields large">
          <label>1. Are there any outstanding judgements against you? <span style="color:red">*</span></label>
          <p-dropdown [options]="yesno" [style]="{'width':'100%'}" [(ngModel)]="declarations_outstanding_judgements" formControlName="DeclarationsJudgements"></p-dropdown>
        </div>
      </div>
      <div class="col-12">
        <div class="input_fields large">
          <label>2. Have you declared bankruptcy within the past 3 years? <span style="color:red">*</span></label>
          <p-dropdown [options]="yesno" [style]="{'width':'100%'}" [(ngModel)]="declarations_declared_bankruptcy" formControlName="DeclarationsBankrupt"></p-dropdown>
        </div>
      </div>
      <div class="col-12">
        <div class="input_fields large">
          <label>3. Have you been foreclosed on or given title or deed in lieu in the last 3 years? <span style="color:red">*</span></label>
          <p-dropdown [options]="yesno" [style]="{'width':'100%'}" [(ngModel)]="declarations_foreclosed" formControlName="DeclarationsForeclosed"></p-dropdown>
        </div>
      </div>
      <div class="col-12">
        <div class="input_fields large">
          <label>4. Are you a party to a lawsuit? <span style="color:red">*</span></label>
          <p-dropdown [options]="yesno" [style]="{'width':'100%'}" [(ngModel)]="declarations_lawsuit" formControlName="DeclarationsLawsuit"></p-dropdown>
        </div>
      </div>
      <div class="col-12">
        <div class="input_fields large">
          <label>5. Have you been charged or found guilty of a criminal offense in the past? <span style="color:red">*</span></label>
          <p-dropdown [options]="yesno" [style]="{'width':'100%'}" [(ngModel)]="declarations_guilty_criminal_offense" formControlName="DeclarationsCriminalOffense"></p-dropdown>
        </div>
      </div>
      <div class="col-12">
        <div class="input_fields large">
          <label>6. Are you presently delinquent or in default on any Federal debt or any other loan, mortgage, financial
            obligation, bond, or loan guarantee? <span style="color:red">*</span></label>
            <p-dropdown [options]="yesno" [style]="{'width':'100%'}" [(ngModel)]="declarations_delinquent_or_default" formControlName="DeclarationsDelinquent"></p-dropdown>
        </div>
      </div>
      <div class="col-12">
        <div class="input_fields large">
          <label>7. Are you a US Citizen? <span style="color:red">*</span></label>
          <p-dropdown [options]="yesno" [style]="{'width':'100%'}" [(ngModel)]="declarations_usa_citizen" formControlName="DeclarationsUSCitizen"></p-dropdown>
        </div>
      </div>
      <div class="col-12">
        <div class="input_fields large">
          <label>8. Are you a permanent resident alien? <span style="color:red">*</span></label>
          <p-dropdown [options]="yesno" [style]="{'width':'100%'}" [(ngModel)]="declarations_permanent_resident" formControlName="DeclarationsPermanentResident"></p-dropdown>
        </div>
      </div>
      <div class="col-12">
        <div class="input_fields large">
          <label>9. Have you, directly or indirectly, been obligated on any loan which resulted in a foreclosure to be initiated,
            transfer of title in lieu of foreclosure, or judgements? (This would include such loans as home mortgage loans,
            SBA loans, home improvement loans, educational loans, manufactured (mobile) home loans, any mortgage,
            financial obligation, bond, or loan guarantee. If “Yes,” provide the details, including date, name and address of
            lender, FHA or VA case number, if any, and reasons for the action.) <span style="color:red">*</span></label>
            <p-dropdown [options]="yesno" [style]="{'width':'100%'}" [(ngModel)]="declarations_obligated_foreclosure" formControlName="DeclarationsObligatedForeclosure"></p-dropdown>
        </div>
      </div>
      <div class="col-12">
        <p>If you answered yes to 1,4, or 6 please provide a detailed letter of explanation with your application.</p>
        <textarea [rows]="2" [cols]="30" [style]="{'width':'100%'}" pInputTextarea autoResize="autoResize" [(ngModel)]="declarations_detailed_explanations" formControlName="DeclarationsExplanations"></textarea>
      </div>
      <div class="col-12">
        <h3>INFORMATION FOR GOVERNMENT MONITORING PURPOSES </h3>
      </div>
      <div class="col-12">
        <p>The following information is requested by the Federal Government for certain types of loans related to a dwelling in order to monitor the
          lender's compliance with equal credit opportunity, fair housing and home mortgage disclosure laws . You are not required to furnish this in
          formation, but are encouraged to do so . The law provides that a lender may not discriminate either on the basis of t his information, or on
          whether you choose to furnish it. If you furnish the information, please provide both ethnicity and race. For race, you may check more
          than one designation. If you do not furnish ethnicity, race, or sex, under Federal regulations, this lender is required to note the information
          on the basis of visual observation and surname if you have made this application in person. If you do not wish to furnish the information,
          please check the box below. (Lender must review the above material to assure that the disclosures satisfy all requirements to which the
          lender is subject under applicable state law for the particular type of loan applied for.)</p>
      </div>
      <div class="col-12 sm:col-12 md:col-6">
        <div class="hedingbox">Borrower:</div>
        <div class="radio-box">
          <p-checkbox binary="true" label="I do not wish to furnish this information." inputId="DoNotFurnishInfo" [(ngModel)]="do_not_furnish_info" formControlName="DoNotFurnishPersonalInfo"></p-checkbox>
        </div>
      </div>
      <div *ngIf="!do_not_furnish_info" class="col-12 sm:col-12 md:col-6">
        <div class="hedingbox">Sex:</div>
        <div class="radio-box">
          <p-radioButton value="true" label="Female" inputId="opt1" formControlName="SexFemale"></p-radioButton>
        </div>
        <div class="radio-box">
          <p-radioButton value="true" label="Male" inputId="opt2" formControlName="SexMale"></p-radioButton>
        </div>
      </div>
      <div *ngIf="!do_not_furnish_info" class="col-12">
        <div class="hedingbox">Ethnicity:</div>
        <div class="radio-box">
          <p-radioButton value="true" label="Hispanic or Latino" inputId="opt3" formControlName="HispanicLatino"></p-radioButton>
        </div>
        <div class="radio-box">
          <p-radioButton value="true" label="Not Hispanic or Latino" inputId="opt4" formControlName="NotHispanicLatino"></p-radioButton>
        </div>
      </div>
      <div *ngIf="!do_not_furnish_info" class="col-12">
        <div class="hedingbox">Race:</div>
        <div class="radio-box">
          <p-radioButton value="true" label="American Indian or Alaska Native" inputId="opt5" formControlName="Indian"></p-radioButton>
        </div>
        <div class="radio-box">
          <p-radioButton value="true" label="Black or African American" inputId="opt6" formControlName="AfricanAmerican"></p-radioButton>
        </div>
        <div class="radio-box">
          <p-radioButton value="true" label="White" inputId="opt7" formControlName="White"></p-radioButton>
        </div>
        <div class="radio-box">
          <p-radioButton value="true" label="Asian" inputId="opt8" formControlName="Asian"></p-radioButton>
        </div>
        <div class="radio-box">
          <p-radioButton value="true" label="Native Hawaiian or Other Pacific Islander" inputId="opt9" formControlName="Hawaiian"></p-radioButton>
        </div>
      </div>
      <div class="col-12">
        <p>To be Completed by Loan Originator: This information was provided: In a face-to-face interview In a telephone interview By the applicant
          and submitted by fax or mail By the applicant and submitted via e-mail or the Internet</p>
      </div>
      <div class="col-12">
        <h3>ACKNOWLEDGEMENT AND AGREEMENT </h3>
      </div>
      <div class="col-12">
        <p>Each of the undersigned specifically represents to Lender and to Lender's actual or potential agents, brokers, processors, attorneys, insurers, servicers,
          successors and assigns and agrees and acknowledges that: (1) the information provided in this application is true and correct as of the date set forth
          opposite my signature and that any intentional or negligent misrepresentation of this information contained in this application may result in civil liability,
          including monetary damages, to any person who may suffer any loss due to reliance upon any misrepresentation that I have made on this application, and/
          or in criminal penalties including, but not limited to, fine or imprisonment or both under the provisions of Title 18, United States Code, Sec. 1001, et seq.; (2) the
          loan requested pursuant to this application (the "Loan") will be secured by a mortgage or deed of trust on the property described in this application; (3) the
          property will not be used for any illegal or prohibited purpose or use; (4) all statements made in this application are made for the purpose of obtaining a
          commercial mortgage loan; (5) the property will be occupied as indicated in this application; (6) the Lender, its servicers, successors or assigns may retain the
          original and/or an electronic record of this application, whether or not the Loan is approved; (7) the Lender and its agents, brokers, insurers, servicers,
          successors, and assigns may continuously rely on the information contained in the application, and I am obligated to amend and/or supplement the
          information provided in this application if any of the material facts that I have represented herein should change prior to closing of the Loan; (8) in the event
          that my payments on the Loan become delinquent, the Lender, its servicers, successors or assigns may, in addition to any other rights and remedies that it
          may have relating to such delinquency, report my name and account information to one or more consumer reporting agencies; (9) ownership of the Loan
          and/or administration of the Loan account may be transferred with such notice as may be required by law; (10) neither Lender nor its agents, brokers,
          insurers, servicers, successors or assigns has made any representation or warranty, express or implied, to me regarding the property or the condition or value
          of the property; and (11) my transmission of this application as an "electronic record" containing my "electronic signature," as those terms are defined in
          applicable federal and/or state laws (excluding audio and video recordings), or my facsimile transmission of this application containing a facsimile of my
          signature, shall be as effective, enforceable and valid as if a paper version of this application were delivered containing my original written signature.
          Acknowledgement. Each of the undersigned hereby acknowledges that any owner of the Loan, its servicers, successors and assigns, may verify or reverify
          any information contained in this application or obtain any information or data relating to the Loan, for any legitimate business purpose through any source,
          including a source named in this application or a consumer reporting agency.</p>
      </div>
      <div class="col-12 sm:col-12 md:col-6">
          <input type="text" pInputText [(ngModel)]="ack_agreement_guarantor_printed_name" formControlName="AckAgreementPrintedName" style="margin-bottom:5px;width:100%">
        <div class="sign_box">Guarantor Printed Name <span style="color:red">*</span></div>
      </div>
      <div class="col-12 sm:col-12 md:col-6">
          <p-calendar [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}" [disabled]="true" [(ngModel)]="ack_agreement_signature_date" formControlName="AckAgreementDate"></p-calendar>
        <div class="sign_box" style="margin-top:5px;">Date</div>
      </div>
      <div class="col-12">
        <div class="signature_pad_box">
          <signature-pad #sigpad2 [options]="signaturePadOptions"  id="AckAgreementSignature" (onEndEvent)="ackAgreementDrawComplete()"></signature-pad>
          <div class="sign_box">Guarantor Signature <span style="color:red">*</span><span (click)="clearAgreementSignature()" style="cursor:pointer;">(Click Here To Clear Signature)</span></div>
        </div>
      </div>
      <div class="col-12">
        <h3>BORROWER SIGNATURE AUTHORIZATION</h3>
      </div>
      <div class="col-12">
        <p>Privacy Act Notice: This information is to be used by the agency collecting it or its assignees in determining whether you
          qualify as a prospective mortgagor under its program. It will not be disclosed outside the agency except as required and
          permitted by law. You do not have to provide this information, but if you do not, your application for approval as a prospective mortgagor or borrower may be delayed or rejected. The information requested in this form is authorized by Title
          38, USC, Chapter 37 (if VA); by 12 USC, Section 1701 et. Seq. (if HUD/FHA); by 42 USC, Section 1452b (if HUD/CPD); and Title
          42 USC, 1471 et. Seq., or 7 USC, 1921 et. seq. (if USDA/FHA). </p>
      </div>
      <div class="col-12">
        <h6>PART 1 - GENERAL INFORMATION</h6>
      </div>
      <div class="col-12">
        <div class="input_fields">
          <label>1. Borrower Name</label>
          {{personal_first_name}} {{personal_last_name}}
        </div>
      </div>
      <div class="col-12">
        <div class="input_fields in_box">
          2. Name and address of Lender/Broker
          <strong>CK Capital LLC, its affiliates, successors and/or assigns. 429 S 119th St. West, Wichita, KS 67235</strong>
        </div>
      </div>
      <div class="col-12 sm:col-12 md:col-4">
        <div class="input_fields">
          <label>3. Date</label>
          {{loan_info_signature_date | date: 'MM/dd/yyyy'}}
        </div>
      </div>
      <div class="col-12 sm:col-12 md:col-4">
        <div class="input_fields">
          <label>4. Social Security Number</label>
          {{personal_ssn}}
        </div>
      </div>
      <div class="col-12 sm:col-12 md:col-4">
        <div class="input_fields">
          <label>4. Date of Birth</label>
          {{personal_date_of_birth | date: 'dd/MM/yyyy'}}
        </div>
      </div>
      <div class="col-12">
        <h6>PART 2 - BORROWER AUTHORIZATION</h6>
      </div>
      <div class="col-12">
        <p>I hereby authorize the Lender/Broker, its affiliates, successors and/or assigns to verify my past and present employment
          earnings records, bank accounts, stock holdings, and any other asset balances that are needed to process my mortgage
          loan application. I further authorize the Lender/Broker, its affiliates, successors and/or assigns to order a consumer credit
          report and criminal background checks to verify other credit information, including but not limited to past and present
          mortgages and landlord references. It is understood that a copy of this form will also serve as authorization. * </p> <br/>
          <p>The information the Lender/Broker, its affiliates, successors and/or assigns obtains is only to be used in the processing of my
            application for a mortgage loan.</p>
      </div>
      <div class="col-12 sm:col-12 md:col-6">
          <input type="text" pInputText [(ngModel)]="borrower_authorization_guarantor_printed_name" formControlName="BorrowerAuthPrintedName" style="margin-bottom:5px;width:100%">
        <div class="sign_box">Guarantor Name Printed <span style="color:red">*</span></div>
      </div>
      <div class="col-12 sm:col-12 md:col-6">
          <p-calendar [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}" [disabled]="true" [(ngModel)]="borrower_authorization_signature_date" formControlName="BorrowerAuthSignatureDate"></p-calendar>
        <div class="sign_box" style="margin-top:5px;">Date</div>
      </div>
      <div class="col-12">
        <div class="signature_pad_box">
          <signature-pad #sigpad3 [options]="signaturePadOptions"  id="signatureCanvas" (onEndEvent)="borrowerAuthDrawComplete()"></signature-pad>
        <div class="sign_box">Guarantor Signature <span style="color:red">*</span><span (click)="clearBorrowerAuthSignature()" style="cursor:pointer;">(Click Here To Clear Signature)</span></div>
      </div>
      </div>
      <div class="col-12">
        <h3>ECOA - EQUAL CREDIT OPPORTUNITY ACT</h3>
      </div>
      <div class="col-12">
        <p>The Federal Equal Credit Opportunity Act prohibits creditors from discriminating against credit applicants on the basis of
          race, color, religion, national origin, sex, marital status, age (provided the applicant has the capacity to enter into a
          binding contract); because all or part of the applicant’s income derives from any public assistance program or because
          the applicant has in good faith exercised any right under the Consumer Credit Protection Act. The Federal Agency that
          administers compliance with this law concerning this company is the Federal Trade Commission, Equal Credit Opportunity,
          Washington, DC 20580. <br/> <br/>
          We are required to disclose to you that you need not disclose income from alimony, child support or separate
          maintenance payments if you choose not to do so. <br/> <br/>
          Having made this disclosure to you, we are permitted to inquire if any of the income shown on your application is derived
          from such a source and to consider the likelihood of consistent payment as we do with any income on which you are
          relying to qualify for the loan for which you are applying.  </p>
      </div>
      <div class="col-12 sm:col-12 md:col-6">
          <input type="text" pInputText [(ngModel)]="ecoa_guarantor_printed_name" formControlName="ECOAPrintedName" style="margin-bottom:5px;width:100%">
        <div class="sign_box">Guarantor Name Printed <span style="color:red">*</span></div>
      </div>
      <div class="col-12 sm:col-12 md:col-6">
          <p-calendar [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}" [disabled]="true" [(ngModel)]="ecoa_signature_date" formControlName="ECOASignatureDate"></p-calendar>
        <div class="sign_box" style="margin-top:5px;">Date</div>
      </div>
      <div class="col-12">
        <div class="signature_pad_box">
          <signature-pad #sigpad4 [options]="signaturePadOptions"  id="signatureCanvas" (onEndEvent)="ecoaDrawComplete()"></signature-pad>
        <div class="sign_box">Guarantor Signature <span style="color:red">*</span><span (click)="clearEcoaSignature()" style="cursor:pointer;">(Click Here To Clear Signature)</span></div>
      </div>
      </div>
      <div class="col-12" style="margin-top:25px;">
        <strong>{{property_address}}, {{property_city}}, {{property_state}}, {{property_zip}}</strong>
        <div class="sign_box">Property Full Address</div>
      </div>
      <div class="col-12">
        <h3>DECLARATION OF NON-OWNER OCCUPANCY</h3>
      </div>
      <div class="col-12">
        <p>I (“Borrower”) certify and represent to Lender (“Originator”) as follows: </p> <br/> <br/>
        <p>I have applied to Originator for a mortgage, deed of trust or other security instrument secured by the real property
          located at: </p> <br/><br/>
        <p> <span class="sign_box1"><strong>{{property_address}}, {{property_city}}, {{property_state}}, {{property_zip}}</strong></span> (the “Property”) for investment purposes. I (“Borrower”) hereby
          declare that neither I nor any member of the borrowing entity are currently utilizing the property as a principal residence.
          Additionally, I declare that neither I nor any member of the borrowing entity are currently utilizing the property as a second
          home. </p> <br/><br/>
        <p>I (“Borrower”) understand and represent that I understand the difference between a consumer loan for personal purposes
          and a commercial loan for business purposes. Borrower represents and understands that this loan is not a consumer loan
          and therefore may not be subject to the various laws relating to consumer loans in the various states or federal laws. I
          declare that all loan proceeds are for investment/business purpose, and no loan proceeds are for consumer, family, and/
          or household purposes. </p>
        <p>The lender, broker, assignees, and successors may rely upon this information. I declare under penalty of perjury the
          foregoing is true and correct.</p>
      </div>
      <div class="col-12 sm:col-12 md:col-6">
        <input type="text" pInputText [(ngModel)]="non_owner_occupancy_guarantor_printed_name" formControlName="NonOwnerOccupancyPrintedName" style="margin-bottom:5px;width:100%">
        <div class="sign_box">Guarantor Name Printed <span style="color:red">*</span></div>
      </div>
      <div class="col-12 sm:col-12 md:col-6">
        <p-calendar [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}" [disabled]="true" [(ngModel)]="non_owner_occupancy_signature_date" formControlName="NonOwnerOccupancySignatureDate"></p-calendar>
        <div class="sign_box" style="margin-top:5px;">Date</div>
      </div>
      <div class="col-12 sm:col-12 md:col-6">
        <div class="signature_pad_box">
        <signature-pad #sigpad5 [options]="signaturePadOptions"  id="signatureCanvas" (onEndEvent)="nonOwnerOccupancyDrawComplete()"></signature-pad>
        <div class="sign_box">Guarantor Signature <span style="color:red">*</span><span (click)="clearNonOwnerOccupancySignature()" style="cursor:pointer;">(Click Here To Clear Signature)</span></div>
      </div>
      </div>
      <div class="col-12 sm:col-12 md:col-6">
        <input type="text" pInputText [(ngModel)]="non_owner_occupancy_entity_name" formControlName="NonOwnerOccupancyEntity" style="margin-bottom:5px;width:100%">
        <div class="sign_box">Entity Name <span style="color:red">*</span></div>
      </div>

      <div class="col-12">
        <p-accordion>
          <p-accordionTab header="Click To Add Additional Business Partner 1" [selected]="false">
            <div class="grid">
              <div class="col-12 sm:col-12 md:col-6">
                <div class="input_fields">
                  <label>First Name</label>
                  <input type="text" pInputText [(ngModel)]="partner_1_first_name" formControlName="Partner1FirstName" />
                </div>
              </div>
              <div class="col-12 sm:col-12 md:col-6">
                <div class="input_fields">
                  <label>Last Name</label>
                  <input type="text" pInputText [(ngModel)]="partner_1_last_name" formControlName="Partner1LastName" />
                </div>
              </div>
              <div class="col-12 sm:col-12 md:col-6">
                <div class="input_fields">
                  <label>Date of Birth</label>
                  <p-calendar [style]="{'width':'100%'}" [monthNavigator]="true" [yearNavigator]="true" yearRange="1900:2050" [showIcon]="true" [inputStyle]="{'width':'85%'}" [(ngModel)]="partner_1_date_of_birth" formControlName="Partner1Birthdate"></p-calendar>
                </div>
              </div>
              <div class="col-12 sm:col-12 md:col-6">
                <div class="input_fields">
                  <label>Social Security Number</label>
                  <p-inputMask [(ngModel)]="partner_1_ssn" [style]="{'width':'100%'}" mask="999-99-9999" formControlName="Partner1SSN"></p-inputMask>
                </div>
              </div>
              <div class="col-12">
                <div class="input_fields">
                  <label>Primary Residence</label>
                  <input type="text" pInputText [(ngModel)]="partner_1_primary_residence" formControlName="Partner1PrimaryResidence" />
                </div>
              </div>
              <div class="col-12 sm:col-12 md:col-6">
                <div class="input_fields">
                  <label>Phone</label>
                  <p-inputMask [(ngModel)]="partner_1_phone" [style]="{'width':'100%'}" mask="(999) 999-9999" formControlName="Partner1Phone"></p-inputMask>
                </div>
              </div>
              <div class="col-12 sm:col-12 md:col-6">
                <div class="input_fields">
                  <label>Email Address</label>
                  <input type="text" pInputText [(ngModel)]="partner_1_email" formControlName="Partner1Email" email/>
                </div>
              </div>
              <div class="col-12">
                <div class="input_fields">
                  <label>Ownership Percentage</label>
                  <input type="number" pInputText [(ngModel)]="partner_1_ownership_percentage" formControlName="Partner1Ownership" />
                </div>
              </div>
            </div>
          </p-accordionTab>
        </p-accordion>
      </div>

      <div class="col-12">
        <p-accordion>
          <p-accordionTab header="Click To Add Additional Business Partner 2" [selected]="false">
            <div class="grid">
              <div class="col-12 sm:col-12 md:col-6">
                <div class="input_fields">
                  <label>First Name</label>
                  <input type="text" pInputText [(ngModel)]="partner_2_first_name" formControlName="Partner2FirstName" />
                </div>
              </div>
              <div class="col-12 sm:col-12 md:col-6">
                <div class="input_fields">
                  <label>Last Name</label>
                  <input type="text" pInputText [(ngModel)]="partner_2_last_name" formControlName="Partner2LastName" />
                </div>
              </div>
              <div class="col-12 sm:col-12 md:col-6">
                <div class="input_fields">
                  <label>Date of Birth</label>
                  <p-calendar [style]="{'width':'100%'}" [monthNavigator]="true" [yearNavigator]="true" yearRange="1900:2050" [showIcon]="true" [inputStyle]="{'width':'85%'}" [(ngModel)]="partner_2_date_of_birth" formControlName="Partner2Birthdate"></p-calendar>
                </div>
              </div>
              <div class="col-12 sm:col-12 md:col-6">
                <div class="input_fields">
                  <label>Social Security Number</label>
                  <p-inputMask [(ngModel)]="partner_2_ssn" [style]="{'width':'100%'}" mask="999-99-9999" formControlName="Partner2SSN"></p-inputMask>
                </div>
              </div>
              <div class="col-12">
                <div class="input_fields">
                  <label>Primary Residence</label>
                  <input type="text" pInputText [(ngModel)]="partner_2_primary_residence" formControlName="Partner2PrimaryResidence" />
                </div>
              </div>
              <div class="col-12 sm:col-12 md:col-6">
                <div class="input_fields">
                  <label>Phone</label>
                  <p-inputMask [(ngModel)]="partner_2_phone" [style]="{'width':'100%'}" mask="(999) 999-9999" formControlName="Partner2Phone"></p-inputMask>
                </div>
              </div>
              <div class="col-12 sm:col-12 md:col-6">
                <div class="input_fields">
                  <label>Email Address</label>
                  <input type="text" pInputText [(ngModel)]="partner_2_email" formControlName="Partner2Email" email />
                </div>
              </div>
              <div class="col-12">
                <div class="input_fields">
                  <label>Ownership Percentage</label>
                  <input type="number" pInputText [(ngModel)]="partner_2_ownership_percentage" formControlName="Partner2Ownership" />
                </div>
              </div>
            </div>
          </p-accordionTab>
        </p-accordion>
      </div>

      

    
      
      <div class="col-12" style="padding-top:30px">
        <h3 class="application_fee">Let's Make This Deal Happen! </h3>
      </div>

      <div class="col-4">

      </div>
      <div class="col-4">
        <form id="payment-form">
            <div id="card-element" class="shadow-6" style="padding:20px;border-radius:5px;">
                <!-- Elements will create input elements here -->
            </div>
            
            <!-- We'll put the error messages in this element -->
            <div style="color:red;font-weight:bold;padding-top:35px" id="card-errors" role="alert"></div>
            
            <br><br>

            <div class="col-12" style="margin-left:auto;margin-right:auto;text-align:center">
              <p-checkbox name="submissionAcknowledgement" [(ngModel)]="submissionAcknowledgement" binary="true" label="I hereby agree that the information on this application is accurate, and that my information on this form may be processed." inputId="SubmissionAck"></p-checkbox>
            </div>
        
            <div id="SubmitContainer" class="submit_button">
              <p-button type="submit" [disabled]="submissionAcknowledgement==false || isSubmitting" (click)="createPaymentMethod()" label="Submit Application $49" icon="pi pi-check"><i *ngIf="isSubmitting" class="pi pi-spinner pi-spin"></i></p-button>
            </div>

            <ng-container *ngIf="isSubmitting">
              <div class="col-12" style="margin-left:auto;margin-right:auto;text-align:center">
                <p-progressSpinner></p-progressSpinner>
              </div>
            </ng-container>
          </form>
      </div>

      <div class="col-4">

      </div>

        <div class="col-12" style="margin-left:auto;margin-right:auto;text-align:center;padding-top:30px">
          <div class="col-12" id="ValidationErrors" style="margin-left:auto;margin-right:auto;text-align:center">
            <!--Put any form validation errors in this container-->
          </div>
          <img src="../assets/powered-by-stripe.png" height=50>
        </div>
      

      <div class="col-12">
      
        <p-steps id="PaymentSteps" [model]="stepItems" [activeIndex]="0" [readonly]="true"></p-steps>
      
      </div>
    </div>
  </form>
</div>


<p-dialog [blockScroll]="true" [closeOnEscape]="false" [closable]="false" 
  [(visible)]="displayStartApplicationModal" [modal]="true" [style]="{width: '50vw'}" [baseZIndex]="10000"
    [draggable]="false" [resizable]="false">
    <h2>Let's Get The Application Started!</h2>
    <div class="grid pt-2">
      <div class="col-12 sm:col-12 md:col-6">
        <span class="p-float-label">
          <input type="text" [style]="{'width':'100%'}" (keyup.enter)="insertNewLead()" pInputText [(ngModel)]="personal_first_name" />
          <label>First Name</label>
        </span>
        
      </div>
      <div class="col-12 sm:col-12 md:col-6">
        <span class="p-float-label">
          <input type="text" [style]="{'width':'100%'}" (keyup.enter)="insertNewLead()" pInputText [(ngModel)]="personal_last_name" />
          <label>Last Name</label>
        </span>
      </div>
  
      <div class="col-12 sm:col-12 md:col-6">
        <span class="p-float-label">
          <input type="text" [style]="{'width':'100%'}" (keyup.enter)="insertNewLead()" pInputText [(ngModel)]="personal_email" />
          <label>Email</label>
        </span>
      </div>
      <div class="col-12 sm:col-12 md:col-6">
        <span class="p-float-label">
          <p-inputMask [style]="{'width':'100%'}" [(ngModel)]="personal_phone_number" mask="(999) 999-9999" (keyup.enter)="insertNewLead()"></p-inputMask>
          <label>Phone</label>
        </span>
      </div>
    </div>
    
        <p-footer>
          <button type="button" id="LeadButton" [disabled]="!personal_first_name || !personal_last_name || !personal_email" pButton icon="pi pi-check" (click)="insertNewLead()" label="Let's Start!"></button>
          <div id="LeadValidationsContainer"></div>
        </p-footer>
</p-dialog>

<p-dialog header="Thank You For Your Application!" [blockScroll]="true" [closeOnEscape]="false" [closable]="false" [(visible)]="applicationSubmittedSuccessfully" [modal]="true" [style]="{width: '50vw'}" [baseZIndex]="10000"
  [draggable]="false" [resizable]="false">
  <p>Your application has been submitted successfully, and you will be hearing from a CK Capital Team Member soon! If you ever have any questions about your application or its status, please don't hesitate to contact us.</p>
      <p-footer>
          <button type="button" id="ApplicationCompleteButton" pButton icon="pi pi-check" (click)="redirectToCkHomePage()" label="Sounds Good!"></button>
      </p-footer>
</p-dialog>


<app-loan-footer></app-loan-footer>